import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';

import { SessionActions } from '../../store/session/session.actions';

@Component({
  selector: 'app-logout-view',
  templateUrl: './logout-view.component.html',
  styleUrls: ['./logout-view.component.scss'],
  standalone: false
})
export class LogoutViewComponent implements OnInit {
  constructor(private store: Store) {}

  ngOnInit() {
    this.store.dispatch(SessionActions.logout());
  }
}
